// extracted by mini-css-extract-plugin
export default {"AppointmentForm":"AppointmentEditOptionsForm_AppointmentForm__D9r8K"};